import { render, staticRenderFns } from "./PickupDataForm.vue?vue&type=template&id=0ca040fd&"
import script from "./PickupDataForm.vue?vue&type=script&lang=ts&"
export * from "./PickupDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports